import React from "react";
import s from "../labReportPdf.module.scss";

const SynovialFluidAnalysisPdf = ({ profile, PageBaseLayout, PageFooter }) => {
  const filterTests = (names) => {
    return profile?.tests?.filter((t) => names.includes(t.testName)) || [];
  };


  const physicalTests = filterTests(["Volume", "Colour", "Appearance", "Clot"]);

  const biochemicalTests = filterTests(["Protein", "Sugar"]);

  const microscopicTests = filterTests([
    "Total Cell",
    "Neutrophils",
    "Lymphocytes",
    "Eosinophils",
    "Macrophages Cell",
    "Abnormal Cell",
    "RBC",
    "Comment",
  ]);

  const RenderSection = ({ title, tests }) => (
    <>
      <tr className={s.sectionHeaderRow}>
        <td
          colSpan="4"
          style={{
            fontWeight: "bold",
            backgroundColor: "#f2f2f2",
            padding: "6px",
            fontSize: "0.9em",
            textTransform: "uppercase",
          }}
        >
          {title}
        </td>
      </tr>
      {tests.map((t, idx) => (
        <tr key={idx}>
          <td style={{ paddingLeft: "15px", borderBottom: "none" }}>
            {t.testName}
          </td>
          <td
            align="center"
            style={{ borderBottom: "none", fontWeight: "bold" }}
          >
            {t.value || "-"}
          </td>
          <td align="center" style={{ borderBottom: "none" }}>
            {t.units || "-"}
          </td>
          <td align="center" style={{ borderBottom: "none" }}>
            {t.reference_range_details || "N/A"}
          </td>
        </tr>
      ))}
    </>
  );

  return (
    <div className={s.reportPage} style={{ pageBreakAfter: "always" }}>
      <PageBaseLayout showSampleType={true} currentSampleType={profile.sampleType} />

      <div className={s.testCategoryHeader}>SYNOVIAL FLUID ANALYSIS</div>

      <table
        className={s.resultsTable}
        style={{ width: "100%", borderCollapse: "collapse" }}
      >
        <thead>
          <tr style={{ backgroundColor: "#fafafa" }}>
            <th style={{ width: "40%", textAlign: "left", padding: "8px" }}>
              Test Description
            </th>
            <th style={{ textAlign: "center" }}>Value(s)</th>
            <th style={{ textAlign: "center" }}>Unit(s)</th>
            <th style={{ textAlign: "center" }}>Reference Range</th>
          </tr>
        </thead>
        <tbody>
          {physicalTests.length > 0 && (
            <RenderSection title="Physical Examination" tests={physicalTests} />
          )}
          {biochemicalTests.length > 0 && (
            <RenderSection
              title="Biochemical Examination"
              tests={biochemicalTests}
            />
          )}
          {microscopicTests.length > 0 && (
            <RenderSection
              title="Microscopic Examination"
              tests={microscopicTests}
            />
          )}
        </tbody>
      </table>

      <PageFooter />
    </div>
  );
};

export default SynovialFluidAnalysisPdf;
